import {
    XPRESSID_ERROR_EVENTS,
    XPRESSID_INFO_EVENTS_DOCUMENT_CAPTURE_CODES,
    XPRESSID_INFO_EVENTS_QR_CODES,
    XPRESSID_INFO_EVENTS_SELFIE_CODES,
    XPRESSID_INFO_EVENTS_VIDEO_CODES,
} from 'components/shared/XpressId/constants';
import {
    BLURRED,
    CAMERA_ERROR,
    CONNECT_ERROR,
    EXPIRED_DOCUMENT,
    INVALID_DOCUMENT,
    LIFE_PROOF_ERROR,
    SCREEN_PRINT_ERROR,
    WRONG_FACE_MATCH,
    NETWORK_ERROR,
    QR_ERROR,
    DETECTION_TIMEOUT,
    CALLCENTER_KO,
    TOKEN_NOT_ALLOWED,
    UNDER_AGE,
} from 'constants/video/status';

export const ERROR_CODES = {
    GENERIC_NETWORK_ERROR: '00',
    RETRY_LIMIT_REACHED: '1',
    NETWORK_FAIL: '5',
    WRONG_MRZ: '21',
    WRONG_ID_MATCH: '22',
    WRONG_FACIAL_MATCH: '23',
    EXPIRED_ID: '24',
    FRAUD: '25',
    SCREEN_PRINT: '26',
    WRONG_LIFE_PROOF: '29',
    VULNERABLE_PERSON: '41',
    UNDER_AGE: '42',
};
export const NO_API_RESPONSE_ERROR_MESSAGE = 'No response';
export const STATUS_CODE_BY_EVENT_CODE = {
    [XPRESSID_ERROR_EVENTS.BlurredImageError]: BLURRED,
    [XPRESSID_ERROR_EVENTS.UnknownDocumentTypeError]: INVALID_DOCUMENT,
    [XPRESSID_ERROR_EVENTS.DocumentTypeMismatchError]: INVALID_DOCUMENT,
    [XPRESSID_ERROR_EVENTS.PassportNotFound]: INVALID_DOCUMENT,
    [XPRESSID_ERROR_EVENTS.DocumentDetectionTimeout]: DETECTION_TIMEOUT,
    [XPRESSID_ERROR_EVENTS.SelfieDetectionTimeout]: DETECTION_TIMEOUT,
    [XPRESSID_ERROR_EVENTS.VideoDetectionTimeout]: DETECTION_TIMEOUT,
    [XPRESSID_ERROR_EVENTS.TokenNotAllowed]: TOKEN_NOT_ALLOWED,
};
export const STATUS_CODE_BY_INFO_EVENT_CODE = {
    [XPRESSID_INFO_EVENTS_DOCUMENT_CAPTURE_CODES.DocumentCameraFailure]: CAMERA_ERROR,
    [XPRESSID_INFO_EVENTS_SELFIE_CODES.SelfieCameraFailure]: CAMERA_ERROR,
    [XPRESSID_INFO_EVENTS_SELFIE_CODES.SelfieCameraFailure]: CAMERA_ERROR,
    [XPRESSID_INFO_EVENTS_VIDEO_CODES.VideoCameraFailure]: CAMERA_ERROR,
    [XPRESSID_INFO_EVENTS_QR_CODES.QRProcessOnboardingError]: QR_ERROR,
};
export const STATUS_CODE_BY_ERROR_CODE = {
    [ERROR_CODES.WRONG_FACIAL_MATCH]: WRONG_FACE_MATCH,
    [ERROR_CODES.EXPIRED_ID]: EXPIRED_DOCUMENT,
    [ERROR_CODES.SCREEN_PRINT]: SCREEN_PRINT_ERROR,
    [ERROR_CODES.WRONG_LIFE_PROOF]: LIFE_PROOF_ERROR,
    [ERROR_CODES.NETWORK_FAIL]: CONNECT_ERROR,
    [ERROR_CODES.GENERIC_NETWORK_ERROR]: NETWORK_ERROR,
    [ERROR_CODES.RETRY_LIMIT_REACHED]: CALLCENTER_KO,
    [ERROR_CODES.UNDER_AGE]: UNDER_AGE,
};
